import contentfulGql from 'js/lib/contentfulGql';

/**
 * Common content model fragments
 */

export const imageFragment = contentfulGql`#graphql
  fragment Image on Asset {
    width
    height
    url
    title
    description
    contentType
  }
`;

export const videoFragment = contentfulGql`#graphql
  fragment Video on Asset {
    sys {
      id
      spaceId
      environmentId
    }
    url
    title
    description
    contentType
  }
`;

export const pdfFragment = contentfulGql`#graphql
  fragment Pdf on Asset {
    sys {
      id
      spaceId
      environmentId
    }
    url
    title
    description
    contentType
  }
`;

export const ctaFragment = contentfulGql`#graphql
  fragment Cta on EntWebsiteCta {
    sys {
      id
    }
    ctaText
    ctaDescription
    ctaTarget
    shouldOpenInNewWindow
    showNewBadge
    invert
  }
`;

export const basicCardFragment = contentfulGql`#graphql
  ${ctaFragment}
  ${imageFragment}
  fragment BasicCard on EntWebsiteBasicCard {
    headline
    eyebrow
    body
    sys {
      id
    }
    cta {
      ...Cta
    }
    media {
      ...Image
    }
  }
`;

export const promoCodeConfigFragment = contentfulGql`#graphql
  fragment PromoCodeConfig on EntWebsitePromoCodeConfig {
    promoCodeUrlQueryValue
    config
  }
`;
